let pack = 2;
let chains = 0;
const money = n => '$' + n.toLocaleString('es-UY');

function render() {
 document.querySelectorAll('[data-offers]').forEach(el => {
 el.innerHTML = [2,1].map(n => `<button class="offer ${pack===n?'selected':''}" data-pack="${n}" aria-pressed="${pack===n}">${n===2?'<span class="badge">PACK AHORRO · AHORRÁS $330</span>':''}<span class="radio" aria-hidden="true"></span><span class="offer-copy"><strong>${n} ${n===1?'DIJE':'DIJES'} TETRAGRAMATÓN</strong><small>${n===2?'Uno para vos y otro para regalar':'Para llevar con vos cada día'}</small></span><span class="price">${n===2?'<del>$1.980</del>':''}${money(n===2?1650:990)}</span></button>`).join('');
 });
 document.querySelectorAll('[data-pack]').forEach(btn=>btn.onclick=()=>{pack=Number(btn.dataset.pack);if(chains>pack)chains=pack;render();});
 const select = document.querySelector('#chains');
 select.innerHTML=Array.from({length:pack+1},(_,n)=>`<option value="${n}">${n===0?'Sin cadena':n+' · +'+money(n*350)}</option>`).join('');select.value=String(chains);
 document.querySelector('#total').textContent=money((pack===2?1650:990)+chains*350);
 document.querySelector('#bag-count').textContent=pack;
 document.querySelectorAll('[data-cta]').forEach(el=>el.textContent=`QUIERO ${pack} POR ${money(pack===2?1650:990)}`);
}
document.querySelector('#chains').onchange=e=>{chains=Number(e.target.value);render();};
const checkoutVariants = {'1-0':'52994630811946','1-1':'52994643132714','2-0':'52994643165482','2-1':'52994643198250','2-2':'52994643231018'};
document.querySelectorAll('[data-checkout]').forEach(el=>el.onclick=()=>{
 const id = checkoutVariants[pack+'-'+chains];
 window.location.assign('https://foltexuy.com/cart/'+id+':1');
});
document.querySelector('[data-single]').onclick=()=>{pack=1;chains=Math.min(chains,1);render();document.querySelector('#packs').scrollIntoView({behavior:'smooth'});};
render();
